import React from 'react';
import Popover from 'material-ui/Popover';
import moment from 'moment';

/**
 * Render bars based on the passed in scales and bar data
 *
 * TODO move this into (replace) ev-charts
 */
export default class BarSeries extends React.Component {
  constructor(props) {
    super(props);

    this.state = {hoveredBar: null};
  }

  getFill(idx, id, highlightedIdx, highlightedId, fill, highlightFill) {
    if (
      idx !== undefined &&
      highlightedIdx !== undefined &&
      idx === highlightedIdx &&
      highlightFill
    ) {
      return highlightFill;
    }

    if (id !== undefined && highlightedId !== undefined && id === highlightedId && highlightFill) {
      return highlightFill;
    }

    return fill;
  }

  /**
   *
   * props:
   * @barWidth:  width of the bars
   * @scales:  {xScale, yScale} used as the data scales for x and y axis
   * @fill: default color of the bars
   * @onSelectBar: click handler for the bars
   * @data: data used to render bars {id?, date, value}.  If id is provided, this is used in the onSelect callback
   * @highlightedId: "active" bar by id.  Used with highlightFill to make a bar stand out
   * @highlightedIdx: "active" bar by index.  Used with highlightFill to make a bar stand out
   * @highlightFill: color for "active" bar
   * @roundingX: rounding xRadius for the top of the bars.  Defaults to barWidth/2
   * @roundingY: rounding yRadius for the top of the bars.  Defaults to barWidth/2
   * @placeholderForZeroPercentage: default bar height as a ratio of the max height if data.value === 0
   * @roundInPixels:  height of the bottom cap.
   *
   *      roundingX is also used to "fill in" the bottom of the bars with another rectangle to make the bottom looked squared off
   *      since svg doesn't allow us to only round the top.
   * @returns {*}
   */
  render() {
    const {
      scales,
      data,
      highlightedIdx,
      highlightedId,
      onSelectBar,
      fill,
      highlightFill,
      barWidth,
      placeholderForZeroPercentage = 0.0,
      // roundInPixels = 15,
      // roundingX,
      // roundingY,
      overlapOffset = 0,
      showTooltips = true,
    } = this.props;
    const {hoveredBar} = this.state;
    if (!scales) return null;
    const {xScale, yScale} = scales;

    // TODO - add rounding back if we need it.
    // const rx = roundingX || barWidth / 2;
    // const ry = roundingY || barWidth / 2;

    const bars = data.map((datum, idx) => {
      // round x to the nearest whole integer. subpixel rendering makes our
      // bottom square hack look funky
      const x = Math.round(xScale(datum.date) + overlapOffset);

      // const capHeight = datum.value === 0 ? placeholderForZero : roundInPixels;
      //
      // const height = scales.yScale.range()[0] - scales.yScale(datum.value);

      // TODO - replace rect below with path to curve the top. Below is the equivalent with path
      // read: https://medium.com/@dennismphil/one-side-rounded-rectangle-using-svg-fb31cf318d90
      // <path
      //   className="bar"
      //   key={datum.id || datum.date}
      //   d={`M${x},${yScale(datum.value)} v${height} q0,5 5,5 h10 q5,0 5,-5 v-${height} z`}
      //   fill={this.getFill(idx, datum.id, highlightedIdx, highlightedId, fill, highlightFill)}
      //   fillOpacity={0.6}
      //   ref={(n) => this["rect-" + datum.date] = n}
      //   onMouseEnter={() => this.setState({hoveredBar: datum.date})}
      //   onMouseLeave={() => this.setState({hoveredBar: null})}
      //   onClick={() => onSelectBar && onSelectBar(datum.id || idx)}
      // /> /* this is the actual bar to get rendered, rx/ry round EVERY corner */
      const yMax = scales.yScale.range()[0];
      const datumValueWithZeroStandIn = !datum.value
        ? yMax * placeholderForZeroPercentage
        : datum.value;
      return (
        <g key={datum.id || datum.date}>
          <rect
            className="bar"
            key={datum.id || datum.date}
            x={x}
            y={yScale(datumValueWithZeroStandIn)}
            height={yMax - yScale(datumValueWithZeroStandIn)}
            width={barWidth}
            fill={this.getFill(idx, datum.id, highlightedIdx, highlightedId, fill, highlightFill)}
            fillOpacity={0.6}
            ref={n => (this['rect-' + datum.date] = n)}
            onMouseEnter={() => this.setState({hoveredBar: datum.date})}
            onMouseLeave={() => this.setState({hoveredBar: null})}
            onClick={() => onSelectBar && onSelectBar(datum.id || idx)}
          />{' '}
          {/* this is the actual bar to get rendered, rx/ry round EVERY corner */}
          <Popover
            className="destyle-popover no-pointer-events"
            canAutoPosition={false}
            open={hoveredBar === datum.date && showTooltips}
            useLayerForClickAway={false}
            anchorEl={this['rect-' + datum.date]}
            anchorOrigin={{
              horizontal: 'middle',
              vertical: 'top',
            }}
            targetOrigin={{
              horizontal: 'middle',
              vertical: 'bottom',
            }}>
            <div className="tooltip-container">
              <div className="ev-tooltip">
                {(this.props.tooltipContent && this.props.tooltipContent(datum)) || (
                  <div className="tooltip-content">
                    <span className={'tooltip-line'}>
                      {`${moment(datum.date).tz('UTC').format('MMM Do YYYY')} Score`}
                    </span>
                    <span className={'tooltip-line'}>{`Overall: ${Math.round(datum.value)}%`}</span>
                  </div>
                )}
              </div>
            </div>
          </Popover>
        </g>
      );
    });
    return <g>{bars}</g>;
  }
}
